import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import versionReducer from './reducers/version';
import authReducer from './reducers/auth';
import assetReviewItems from './reducers/assetReviewItems';
import collections from './reducers/collections';
import coupons from './reducers/coupons';
import profilesReducer from './reducers/profiles';
import companiesReducer from './reducers/companies';
import modal from './reducers/modal';
import mobile from './reducers/mobile';
import imagesReducer from './reducers/images';
import settingsReducer from './reducers/settings';
import navReducer from './reducers/Navigation';
import surveyReducer from './reducers/surveys';
import sessionReducer from './reducers/session';
import userSurveyDataReducer from './reducers/userSurveyData';
import userEventsDataReducer from './reducers/userEvents';
import userLearningAssets from './reducers/userLearningAssets';
import filesReducer from './reducers/files';
import globalSectionItems from './reducers/globalSectionItems';
import globalContentRows from './reducers/globalContentRows';
import workspaceReducer from './reducers/workspace';
import notes from './reducers/notes';
import badges from './reducers/badges';
import bookmarks from './reducers/bookmarks';
import learningAssets from './reducers/learningAssets';
import userCollections from './reducers/userCollections';
import suppressionData from './reducers/suppressionData';
import language from './reducers/language';
import welcomeReducer from './reducers/welcome';
import behaviors from './reducers/behaviors';
import abilities from './reducers/abilities';
import dimensions from './reducers/dimensions';
import admin from './reducers/admin';
import peerRecommendations from './reducers/peerRecommendations';
import welcomeAssets from './reducers/welcomeAssets';
import userWelcomeAssets from './reducers/userWelcomeAssets';
import teams from './reducers/teams';
import algoliaSearch from './reducers/algoliaSearch';
import learningFrameworks from './reducers/learningFrameworks';
import pathways from './reducers/pathways';
import userPathways from './reducers/userPathways';
import localStorage from './reducers/localStorage';
import userFeedback from './reducers/userFeedback';
import userResponses from './reducers/userResponses';

export default combineReducers({
    abilities,
    admin,
    algoliaSearch,
    assetReviewItems,
    auth: authReducer,
    badges,
    behaviors,
    bookmarks,
    collections,
    companies: companiesReducer,
    coupons,
    dimensions,
    files: filesReducer,
    form: formReducer,
    images: imagesReducer,
    globalSectionItems,
    globalContentRows,
    language,
    learningAssets,
    learningFrameworks,
    localStorage,
    pathways,
    mobile,
    modal,
    nav: navReducer,
    notes,
    peerRecommendations,
    profiles: profilesReducer,
    session: sessionReducer,
    settings: settingsReducer,
    suppressionData,
    surveys: surveyReducer,
    teams,
    userCollections,
    userEvents: userEventsDataReducer,
    userPathways,
    userSurveyData: userSurveyDataReducer,
    workspace: workspaceReducer,
    userLearningAssets,
    version: versionReducer,
    welcome: welcomeReducer,
    welcomeAssets,
    userWelcomeAssets,
    userFeedback,
    userResponses
});
